import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { EditableDirective } from './editable.directive';
import { EditableInterfaceComponent } from './editable.types';
import { TextEditableComponent } from './text-editable/text-editable.component';
import { DateEditableComponent } from './date-editable/date-editable.component';
import { DateTimeEditableComponent } from './datetime-editable/datetime-editable.component';
import { DecimalEditableComponent } from './decimal-editable/decimal-editable.component';
import { NumberEditableComponent } from './number-editable/number-editable.component';
import { MoneyEditableComponent } from './money-editable/money-editable.component';
import { ImagesEditableComponent } from './images-editable/images-editable.component';
import { PercentEditableComponent } from './percent-editable/percent-editable.component';
import { TagsEditableComponent } from './tags-editable/tags-editable.component';
import { TextAreaEditableComponent } from './textarea-editable/textarea-editable.component';
import { TypeaheadEditableComponent } from './typeahead-editable/typeahead-editable.component';
import { SelectEditableComponent } from './select-editable/select-editable.component';
import { YearEditableComponent } from './year-editable/year-editable.component';
import { CheckboxEditableComponent } from './checkbox-editable/checkbox-editable.component';
import { UrlEditableComponent } from './url-editable/url-editable.component';
import { RecordEditableComponent } from './record-editable/record-editable.component';
import { FieldMaskUtils } from '../../Utils/field-mask.utils';

const editableComponents = {
  text: TextEditableComponent,
  date: DateEditableComponent,
  datetime: DateTimeEditableComponent,
  decimal: DecimalEditableComponent,
  number: NumberEditableComponent,
  money: MoneyEditableComponent,
  images: ImagesEditableComponent,
  percent: PercentEditableComponent,
  tags: TagsEditableComponent,
  textarea: TextAreaEditableComponent,
  typeahead: TypeaheadEditableComponent,
  select: SelectEditableComponent,
  year: YearEditableComponent,
  checkbox: CheckboxEditableComponent,
  url: UrlEditableComponent,
  record: RecordEditableComponent,
  id: NumberEditableComponent,
};

@Component({
  selector: 'app-editable',
  templateUrl: './editable.component.html',
  styleUrls: ['./editable.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditableComponent implements OnChanges {
  @Input() fieldDef: any;
  @Input() model: any;
  @Input() data: any;
  @Input() readonly = false;
  @Input() showEmptyHolder = false;
  @Input() editMode = false;
  @Input() showRecordActions = true;
  @Input() meta: { origin: string };
  @Output() onUpdate: EventEmitter<string> = new EventEmitter();
  @Output() onEndEditing: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild(EditableDirective, { static: true }) editableHost: EditableDirective;

  ngOnChanges(changes: SimpleChanges) {
    this.loadComponent();
  }

  loadComponent(): void {
    if (this.fieldDef?.type && editableComponents[this.fieldDef.type]) {
      const viewContainerRef = this.editableHost.viewContainerRef;
      viewContainerRef.clear();

      const componentRef = viewContainerRef.createComponent(editableComponents[this.fieldDef.type]);
      const componentInstance = componentRef.instance as EditableInterfaceComponent;
      componentInstance.model = this.model;
      componentInstance.fieldDef = this.fieldDef;
      componentInstance.data = this.data;
      componentInstance.readonly = this.readonly;
      componentInstance.update = this.onUpdate;
      componentInstance.showEmptyHolder = this.showEmptyHolder;
      componentInstance.editMode = this.editMode;
      componentInstance.showRecordActions = this.showRecordActions;
      componentInstance.meta = this.meta;
      componentInstance.onEndEditing = this.onEndEditing;
      componentInstance.fieldMask = FieldMaskUtils.maskFormattingFunctionsMap[this.fieldDef.name];
    }
  }
}
